<template>
  <div class="modalnobefore">
    <div class="flex-box max64">
      <div class="top">
        <span>部门：</span>
        <Cascader :data="orgData" class="s-cas" @on-change="checkDept" change-on-select></Cascader>
      </div>
<!--      <div class="top">-->
<!--        <span>一级部门：</span>-->
<!--        <Select v-model="organOne" class="s-select" @on-change="checkOneDept">-->
<!--          <Option value="">请选择</Option>-->
<!--          <Option v-for="(item, index) in orgOneList" :value="item.value" :key="'keyA' + index">{{-->
<!--              item.text-->
<!--            }}</Option>-->
<!--        </Select>-->
<!--      </div>-->
<!--      <div class="top">-->
<!--        <span>二级部门：</span>-->
<!--        <Select v-model="organTwo" class="s-select" @on-change="checkTwoDept">-->
<!--          <Option value="">请选择</Option>-->
<!--          <Option v-for="(item, index) in orgTwoList" :value="item.value" :key="'keyA' + index">{{-->
<!--              item.text-->
<!--            }}</Option>-->
<!--        </Select>-->
<!--      </div>-->
<!--      <div class="top">-->
<!--        <span>三级部门：</span>-->
<!--        <Select v-model="organThree" class="s-select" @on-change="checkThreeDept">-->
<!--          <Option value="">请选择</Option>-->
<!--          <Option v-for="(item, index) in orgThreeList" :value="item.value" :key="'keyA' + index">{{-->
<!--              item.text-->
<!--            }}</Option>-->
<!--        </Select>-->
<!--      </div>-->
      <div class="top">
        <span>员工姓名：</span>
        <Select
            v-model="userInfoList"
            :key="sn"
            :multiple="true"
            filterable
            class="s-select"
            @on-change="checkAllUser"
        >
          <Option value="all">全部选择</Option>
          <Option v-for="(item, index) in userList" :value="item.value" :key="'keyA' + index">{{
              item.text
            }}</Option>
        </Select>
      </div>
      <Button type="ghost" @click="rept" class="btn-width" :style="{ width: '90px' }">重置</Button>
      <Button type="primary" @click="ok" class="btn-width" :style="{ width: '90px' }">查询</Button>
    </div>
    <div class="content-box">
      <div id="container" class="content-l"></div>
      <div class="content-r">
        <div class="r-title">
          员工轨迹列表

          <span class="refresh" @click="getList">刷新</span>
        </div>
        <ul class="content">
          <li v-for="(i, index) in dataList" :key="'t' + index">
            <p>
              <span class="r-name" @click="nameClick(i.personCode, i.trajectoryRecordTime)">{{
                  i.personName
                }}</span>
              <span v-if="i.isUnusual == 1" style="float: right; color: red">
                <img
                    :src="img1"
                    style="width: 20px; height: 20px; vertical-align: top; margin-top: 2.5px; margin-rigth: 10px"
                />
                停留时间过长</span
              >
            </p>
            <p><span style="font-weight: bold">实时位置：</span>{{ i.trajectoryAddress }}</p>
            <p><span style="font-weight: bold">定位时间：</span>{{ i.trajectoryRecordTimeStr }}</p>
          </li>
        </ul>
        <Page style="padding: 20px" :total="total" show-total @on-change="changePage"></Page>
      </div>
    </div>
  </div>
</template>

<script>
import img from '@/assets/amap_person.png';
import img1 from '@/assets/back.png';
import timeOver from '@/assets/time_over.png';
import { getUserTrajectory } from '../../api/trajectory';
import { getOrganList } from '../../api/common';
import { getUserList } from '../../api/common';
import { getTrajectoryList } from '../../api/trajectory';
import { getLinkedOrgData } from '../../api/trajectory';
import { parseRegionPaths } from '@/utils/trajectoryMap';

export default {
  data() {
    return {
      departmentList: [
        {
          value: 'beijing',
          name: '北京市',
        },
      ],
      img: img,
      img1: img1,
      departmentListTwo: [],
      nameList: [],
      dataList: [],
      current: 1,
      limit: 10,
      organOne: '',
      orgOneList: [],
      organTwo: '',
      orgTwoList: [],
      organThree: '',
      orgThreeList: [],
      areaFids: [],
      areaList: [],
      userList: [],
      userInfoList: [],
      selectedAll: true,
      map: null,
      path: [],
      markerList: [],
      total: 0,
      sn: 0,
      arrPath: [],
      orgData:[],
      orgValue:'',
      regionPolygons: [],
    };
  },
  created() {
    // this.getOneOrganList();
    this.getLinkedOrgData();
  },
  mounted() {
    this.init();
  },
  methods: {
    getLinkedOrgData(){
      getLinkedOrgData({})
          .then((res) => {
            if (!res.data) return;
            this.orgData = res.data;
          })
          .catch(() => {
            return;
          });
    },
    getOneOrganList() {
      getOrganList({})
          .then((res) => {
            if (!res.data) return;
            this.orgOneList = res.data.orgList;
          })
          .catch(() => {
            return;
          });
    },
    ok() {
      this.getList();
    },
    rept() {
      this.departmentList = [
        {
          value: 'beijing',
          name: '北京市',
        },
      ];
      this.departmentListTwo = [];
      this.nameList = [];
    },
    checkOneDept(val) {
      var param = {
        orgUid: val,
      };
      getOrganList(param)
          .then((res) => {
            if (!res.data) return;
            this.$nextTick(() => {
              this.userInfoList = [];
              this.organTwo = [];
              this.organThree = [];
              this.orgTwoList = res.data.orgList;
            });
          })
          .catch(() => {
            return;
          });
    },
    checkTwoDept(val) {
      if (!val.length) return;
      var param = {
        orgUid: val,
      };
      getOrganList(param)
          .then((res) => {
            if (!res.data) return;
            this.$nextTick(() => {
              this.userInfoList = [];

              this.organThree = [];
              this.orgThreeList = res.data.orgList;
            });
          })
          .catch(() => {
            return;
          });
    },
    checkThreeDept(val) {
      if (!val.length) return;
      getUserList({
        organUid: val,
        departure: 1,
      })
          .then((res) => {
            if (!res.data) return;

            this.userInfoList = [];

            this.$nextTick(() => {
              this.sn++;
              this.userList = res.data.userList;
            });
          })
          .catch(() => {
            return;
          });
    },
    checkDept(val) {
      if (!val.length) return;
      getUserList({
        organUids: val,
        departure: 1,
      })
          .then((res) => {
            if (!res.data) return;

            this.userInfoList = [];

            this.$nextTick(() => {
              this.sn++;
              this.userList = res.data.userList;
            });
          })
          .catch(() => {
            return;
          });
    },
    checkAllUser(val) {
      console.log(this.userList);
      this.userInfoList = val;
      let isCheck = false;
      for (var property in this.userInfoList) {
        if (this.userInfoList[property] === 'all') {
          isCheck = true;
          this.selectedAll = !this.selectedAll;
        }
      }
      if (isCheck && this.selectedAll) {
        const values = [];
        for (var property in this.userList) {
          values.push(this.userList[property].value);
        }
        this.userInfoList = values;
      }
      if (isCheck && !this.selectedAll) {
        this.userInfoList = [];
      }
    },
    changePage(val) {
      this.current = val;
      this.getList();
    },
    getList() {
      if (this.userInfoList.length === 0) {
        this.$Message.info('所选人员为空');
        return;
      }
      getTrajectoryList({
        clockPersonCode: this.userInfoList,
        page: this.current,
        limit: this.limit,
      })
          .then((res) => {
            if (!res.data) return;

            this.dataList = res.data.dataList;
            this.total = res.data.total;
            //移除suoyou
            this.map.clearMap();
            this.markerList = [];
            //添加覆盖物
            this.getMarke();
            this.getRegion();
          })
          .catch(() => {
            return;
          });
    },
    getRegion() {
      getUserTrajectory({
        clockPersonCode: this.userInfoList,
      })
          .then((res) => {
            if (!res.data) return;
            this.regionPolygons = [];
            const rings = parseRegionPaths(res.data.path);
            rings.forEach((ring) => {
              if (!ring.length) return;
              const polygon = new AMap.Polygon({
                path: ring,
                strokeColor: 'blue',
                strokeStyle: 'dashed',
                fillOpacity: 0.4,
                fillColor: '#1791fc',
                zIndex: 50,
              });
              this.regionPolygons.push(polygon);
              this.map.add(polygon);
            });
            if (this.map.getAllOverlays().length) {
              this.map.setFitView(this.map.getAllOverlays());
            }
          })
          .catch(() => {});
    },
    init() {
      this.map = new AMap.Map('container', {
        center: [116.400274, 39.905812],
        zoom: 14,
      });
      AMap.plugin('AMap.ToolBar', () => {
        //异步加载插件
        var toolbar = new AMap.ToolBar();
        this.map.addControl(toolbar);
      });

      // this.getList();
    },
    getMarke() {
      if (this.dataList.length == 0) return;
      this.dataList.forEach((i) => {
        if (i.longitude && i.latitude){
          let content;
          if (i.isUnusual == 1) {
            // <img src=${img1} style="width:20px;height:20px;vertical-align: top;margin-top: 2.5px;margin-left: 10px;">
            content = `<div style=" background: #549ece;padding: 0 20px;border-radius: 25px;width: max-content;height: 25px;line-height: 25px; color: #fff;">${i.personName}
<img src="${timeOver}" style="height:20px;width: 20px;vertical-align: middle;margin-left: 10px"></div>`;
          }
              // else if (i.state == 2) {
              //   content = `<div style="background: url(${img});background-size: 100% 100%;width: 90px;height: 25px;padding-left: 30px;line-height: 25px; color: #fff;">${i.name}</div>`;
          // }
          else {
            content = `<div style="background: #549ece;padding: 0 20px;border-radius: 25px;width: max-content;height: 25px;line-height: 25px; color: #fff;">${i.personName}</div>`;
          }
          var marker = new AMap.Marker({
            position: [Number(i.longitude), Number(i.latitude)],
            offset: new AMap.Pixel(-30, -10), //图标偏移量
            content: content,
          });
          marker.on('click', (e) => this.getContent(e, i));
          this.markerList.push(marker);
          this.map.add(this.markerList);
        }
      });

      //
    },
    getContent(e, i) {
      var infoWindow = new AMap.InfoWindow({
        anchor: 'top-left',
        content: `<div>
            <div style="height:30px;line-height:30px;overflow:hidden;width:100%;background:#F9F9F9;padding-left:10px">
                ${i.personName}
                <span style="color:green;float:right;margin-right:20px">状态：定位成功</span>
            </div>
            <div class="info-content">
             <p>实时位置：${i.trajectoryAddress}</p><br>
             <p>定位时间：${i.trajectoryRecordTime}</p>
             ${
            i.isUnusual == 1
                ? `<p style="color:red"><img src=${img1} style="width:20px;height:20px;vertical-align: top;margin-top:2.5px;margin-rigth: 10px;"> 停留时间过长</p>`
                : ''
        }

            </div>
        </div>`,
      });
      this.map.clearInfoWindow();
      infoWindow.open(this.map, [e.lnglat.lng, e.lnglat.lat]);
      this.map.setCenter([e.lnglat.lng, e.lnglat.lat]);
    },
    nameClick(i, t) {
      // this.markerList[i].emit('click', {
      //   lnglat: this.markerList[i].getPosition(),
      // });
      this.$router.push({ path: '/app/trajectorytrends', query: { id: i, time: t } });
    },
  },
};
</script>
<style>
.ivu-select-multiple .ivu-select-selection{
  height: 32px;
  line-height: 32px;
  position: relative;
}
</style>
<style lang="less" scoped>
.modalnobefore {
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.flex-box {
  display: flex;
  margin-bottom: 24px;
  & > div {
    flex: auto;
    display: flex;
    margin-right: 20px;
    span {
      display: flex;
      width: auto;
      line-height: 30px;
    }
    .s-select {
      //overflow-y: hidden;
      height: 32px;
      line-height: 30px;
      width: 200px;
      /deep/ .ivu-select-selection {
        max-height: 32px !important;
        overflow: auto !important;
      }
    }
  }
}

.s-cas {
  height: 32px;
  width: 200px;
}

.content-box {
  flex: 1;
  overflow: hidden;
  display: flex;
  .content-l {
    width: 70%;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
  }
  .content-r {
    flex: auto;
    overflow-y: auto;
    .r-title {
      background: #649dd6;
      color: #fff;
      padding-left: 20px;
      height: 30px;
      line-height: 30px;
      .refresh {
        color: #fff;
        cursor: pointer;
        float: right;
        margin-right: 20px;
      }
    }
    .content {
      padding: 20px;
      li {
        border-bottom: 1px solid #ccc;
        margin-bottom: 10px;
        &:last-child {
          border-bottom: none;
        }
        p {
          height: 30px;
          line-height: 30px;
          .r-name {
            font-weight: bold;
            color: green;
            cursor: pointer;
            display: inline-block;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
#container {
  /deep/ .amap-info-content {
    padding: 0;
    background: #fff;
    min-width: 250px;
  }
  /deep/ .amap-info-close {
    right: 0 !important;
    top: 3px;
  }
  /deep/ .info-content {
    padding: 10px;
    p {
      line-height: 25px;
      height: 25px;
      padding: 5px;
      color: #333;
      word-break: break-all;
      width: 200px;
    }
    margin-bottom: 10px;
  }
}
</style>
